export interface BaseFileModel {
  id: number;
  name: string;
  fileSize: number;
  fileType: string;
}
